export class ResourceCreationError extends Error {
  constructor(resource: string, reason?: string) {
    reason = reason ? `: ${reason}` : "";
    super(`Failed to create ${resource}${reason}`);
    this.name = "ResourceCreationError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
